//Reference: EN121

import { Mappeable } from './mappeable.model';
import moment from 'moment';
import * as _ from 'lodash';

export class PersonalInformation extends Mappeable {
    nmrMobile: number;
    txtName: string;
    txtLastname1: string;
    txtLastname2: string;
    txtMail: string;
    specialties: any;

    constructor(o) {
        super(o);
    }

    public mapToBack() {
        return {
            nmrMobile: this.nmrMobile,
            txtName: this.txtName,
            txtLastname1: this.txtLastname1,
            txtLastname2: this.txtLastname2,
            txtMail: this.txtMail,
            specialties: this.transformSpecialties(this.specialties)
        }
    }

    transformSpecialties(specialties) {
        let formatSpecialty = []
        _.forEach(specialties, (specialty) => {
            formatSpecialty.push({ typeSpecialityFk: specialty })
        })
        return formatSpecialty;
    }


}